const sybilColor = "#55B691"

export default sybilColor